import Administracao from '@/spa/administracao/Administracao';

export default {
  path: 'administracao',
  name: 'administracao',
  component: Administracao,
};
